import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FaDuotoneIconComponent } from '@fortawesome/angular-fontawesome';
import { faLanguage } from '@fortawesome/pro-duotone-svg-icons/faLanguage';
import { TAppLanguage } from '../../../schemas/settings';

/**
 * Decorative flag for an interface language; `null` (Automatic) shows a
 * language icon instead. Inline SVG rather than emoji flags, which Windows
 * renders as two letters. English uses the United Kingdom and Portuguese
 * Brazil, matching the Brazilian translations. Size it with `--flag-height`.
 */
@Component({
  selector: 'andor-language-flag',
  standalone: true,
  imports: [FaDuotoneIconComponent],
  templateUrl: './language-flag.html',
  styleUrl: './language-flag.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'aria-hidden': 'true',
    '[class.is-automatic]': 'isAutomatic()',
  },
})
export class LanguageFlag {
  readonly language = input<TAppLanguage | null>(null);

  protected readonly isAutomatic = computed(() => this.language() === null);
  protected readonly faLanguage = faLanguage;
}
